import { useRegion } from 'common/hooks/region';
import { Permission, useHasPermission } from 'utils/permissions';
import { PortCollectionFeature } from 'types/Port';
import { FeatureFlag, useFeatureFlag } from 'utils/permissions/feature-flags';

interface SmartPerDiemOverridesAll {
  mode: 'all';
}

interface SmartPerDiemOverridesInactive {
  mode: 'inactive';
}

interface SmartPerDiemOverridesSelection {
  mode: 'selection';
  codes: string[];
}

type SmartPerDiemOverride =
  | SmartPerDiemOverridesAll
  | SmartPerDiemOverridesInactive
  | SmartPerDiemOverridesSelection;

export function useShowSmartPerDiem(): boolean {
  // Check if the user has permission to view smart per diem
  const hasPermission = useHasPermission([Permission.PerDiemSmartPerDiemView]);

  // Check if the region supports smart per diem
  const region = useRegion();
  const supported = !!region.features?.includes(PortCollectionFeature.SmartPerDiem);

  // Logic for allowing feature flag region overrides
  const overrideRegions = useFeatureFlag<SmartPerDiemOverride>(FeatureFlag.SmartPerDiemOverrides);
  if (overrideRegions) {
    const { mode } = overrideRegions;
    if (mode === 'all') {
      return true;
    }
    if (mode === 'selection') {
      const { codes } = overrideRegions;
      if (codes.includes(region.code)) {
        return true;
      }
    }
  }

  return supported && hasPermission;
}
